export const TITLE_FOLLOW_UP = 'Follow up';
export const TRASH_LABEL = 'Excluir';
export const BACK_BUTTON_LABEL = 'Voltar';
